let isTrackingEnabled = false
// let label = null

export function initialize (trackingEnabled) {
  isTrackingEnabled = trackingEnabled
  // label = name
}

export function trackAction (action, label) {
  sendToGoogleAnalytics({
    category: 'dh-innafor-voldsepisoder-bergen',
    action,
    label
  })
}

function sendToGoogleAnalytics ({ category, action, label }) {
  if (window.ga && isTrackingEnabled) {
    window.ga('send', 'event', category, action, label)
  } else {
    if (typeof console !== 'undefined') {
      console.log(category, action, label)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/googleAnalytic.js